<template>
  <div>
    <v-dialog v-model="dialog" max-width="700px" scrollable persistent>
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Exportar inventarios de un usuario</v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-2 my-2"
                text
                fab
                small
                v-on="on"
                @click.stop="close"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="formExport" @submit.prevent="save">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.identification"
                    label="Documento del usuario"
                    :rules="rules.name"
                    autofocus
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary " @click="close">Cancelar</v-btn>
          <v-btn color="primary " @click="save" :loading="loading"
            >Buscar...</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { URL_APP } from "../../../util/constants";
import { createLinkFile } from "../../../util/functions";

export default {
  name: "ExportInventoryForUser",
  data() {
    return {
      editedItem: { identification: null },
      defaultItem: { identification: null },
      dialog: false,
      valid: true,

      rules: {
        identification: [
          (v) => !!v || "Campo requerido",
          (v) => v.length >= 5 || "Mínimo 5 caracteres",
          (v) => v.length < 100 || "Máximo 100 letras",
        ],
      },
    };
  },

  computed: {
    ...mapGetters(["loading", "updateAssetThird"]),
  },

  methods: {
    ...mapActions(["chgLoad", "getAssetThirdByIdentification"]),
    openDialog() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },

    async findThird() {
      try {
        await this.getAssetThirdByIdentification(
          this.editedItem.identification
        );
        return true;
      } catch (error) {
        return false;
      }
    },

    async save() {
      this.chgLoad(true);
      try {
        const exists = await this.findThird();
        if (!exists) {
          this.$root.$alert({
            text: "Usuario no encontrado",
            color: "error",
            timeout: 2000,
          });
          this.chgLoad(false);
          return;
        }

        const url = URL_APP + "/api/loan_assets/export_assets_by_user";
        const response = await this.$http.get(url, {
          params: this.editedItem,
          responseType: "blob",
        });

        createLinkFile(response);
        this.$root.$alert({
          text: "Descarga exitosa",
          color: "success",
          timeout: 2000,
        });

        this.close();
      } catch (error) {
        console.log(error);
        this.$root.$alert({
          text: "Error al descargar el archivo",
          color: "error",
          timeout: 2000,
        });
      }
      this.chgLoad(false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
